import { Close } from '@dreamstack/icons/src/icon-components/Close'
import { Popover } from '@headlessui/react'
import type { FunctionComponent, MouseEvent } from 'react'
import { default as React } from 'react'
import ReactPortal from './ReactPortal'

export const SimpleNotificationPopover: FunctionComponent<
  React.PropsWithChildren<{
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    setPopperElement: React.Dispatch<(prevState: undefined) => undefined>
    styles: any
    attributes: any
    open: boolean
    showButtons?: boolean
  }>
> = ({ setOpen, setPopperElement, styles, attributes, open, children }) => {
  return (
    <Popover>
      {open && (
        <ReactPortal wrapperId="react-portal-modal-container">
          <Popover.Panel
            ref={setPopperElement}
            onClick={(event: MouseEvent<Element>) => event.preventDefault()}
            className="cursor-default z-10"
            style={styles.popper}
            {...attributes.popper}
            static
          >
            <div className="px-px-8 sm:px-0">
              <div className="sm:min-w-[340px] sm:max-w-[400px] shadow-[0_2px_19px_0_rgba(0,0,0,0.2)]">
                <div className="flex flex-wrap md:flex-nowrap bg-accentroWhite-full text-accentroGray-full p-px-24 relative">
                  <Close
                    onClick={(event) => {
                      event.stopPropagation()
                      event.preventDefault()
                      setOpen(false)
                    }}
                    className="absolute cursor-pointer top-px-16 right-px-16 h-px-20 w-px-20 text-accentroGray-500 z-10"
                  />
                  {children}
                </div>
              </div>
            </div>
          </Popover.Panel>
        </ReactPortal>
      )}
    </Popover>
  )
}
